import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiMembersPrivatePersonalMemoMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    content: RawDraftContentState;
    attachFiles?: File[];
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ privatePersonalMemo: body });
  return new ApiClient()
    .put<ApiMembersPrivatePersonalMemoMutateType>(
      `/api/members/private_personal_memos/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersPrivatePersonalMemosUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersPrivatePersonalMemoMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
